import { type ReactNode, createContext, useContext, useState } from "react";

interface MobileMenuContextType {
    isOpen: boolean;
    setMenu: (isOpen: boolean) => void;
}

const MobileMenuContext = createContext<MobileMenuContextType | undefined>(
    undefined,
);

export const MenuProvider = ({ children }: { children: ReactNode }) => {
    const [isOpen, setMenu] = useState(false);

    return (
        <MobileMenuContext.Provider value={{ isOpen, setMenu }}>
            {children}
        </MobileMenuContext.Provider>
    );
};

export const MenuContext = (): MobileMenuContextType => {
    const context = useContext(MobileMenuContext);

    if (context === undefined) {
        throw new Error(
            "useMobileMenu debe ser usado dentro de un MobileMenuProvider",
        );
    }
    return context;
};

export const useMenu = () => {
    const { isOpen, setMenu } = MenuContext();
    return {
        isOpen,
        openMenu: () => setMenu(true),
        closeMenu: () => setMenu(false),
        toggleMenu: () => setMenu(!isOpen),
    };
};
